import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(
    private http: HttpClient,
    private message: NzMessageService,
  ) {}

  createCustomer(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/customer/create`, payload);
  }

  getCustomerPaged(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/customer/get-paged`, payload);
  }

  getCustomerById(payload: any): Observable<any> {
    return this.http.get(
      `${SETTINGS.BASE_API}/customer/get/${payload}`,
      payload,
    );
  }

  getCustomerBookings(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/customer/get-bookings`,
      payload,
    );
  }

  getCustomerByFilter(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/customer/get-customer-filter`,
      payload,
    );
  }

  getAllActiveCustomers(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/customer/get-all-active`);
  }

  getCustomerByEmail(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/customer/get-by-email`,
      payload,
    );
  }

  updateCustomer(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/customer/update`, payload);
  }

  deleteCustomer(id: any): Observable<any> {
    return this.http.delete(`${SETTINGS.BASE_API}/customer/soft-delete/${id}`);
  }

  fetchJsonData(): Observable<any> {
    return this.http.get('assets/countries.json');
  }
}
